import Button from "@/components/Form/Button/Button";
import {
  MotifErrorMessage,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ControlSelect from "./SelectBox/editFieldSelectBox";
import ControlInputBoxNumber from "@/components/Form/InputBox/ControlInputBoxNumber";
import ControlCheckBox from "./Checkbox";
import {
  getDistributionYear,
  renderOptionList,
} from "../Form/calculationSummaryHelper";
import {
  useCreateLimitAmountMutation,
  useGetDistributionApiDataQuery,
  useGetLimitAmountSummaryApiDataQuery,
  useGetListCalculationStepQuery,
  useUpdateLimitAmountMutation,
} from "../calculationStepReducer";
import { useGetDistributionWithSameSequenceIdQuery } from "@/services/distribution/distributionReducers";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { capitalizeWordsInSentence } from "@/utility/common";
import FutureReferencingLogic from "../Form/FutureReferencingLogic";
import { isNumericOrNull } from "@/utility/validation";
import { useParams } from "react-router-dom";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { DistributionStepContext } from "../../summery/DistributionContext";

export default function LimitAmountForm({
  caseId,
  stepId,
  updateShow,
  setUpdateShow,
  refetch,
  manualDataSource,
  editId,
  resolvedStatus,
}: any) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    reset,
    watch,
    setError,
    formState: { errors, isDirty },
  } = useForm<any>();
  const [isFrenchSelected, setIsFrenchSelected] = useState(false);
  const [isDistributionSeq, setIsDistributionSeq] = useState(false);
  const distributionStepContextData: any = useContext<any>(
    DistributionStepContext
  );

  let defaultOption = {
    label: t("global.globalActions.optionDefault"),
    value: "",
  };
  const checkBoxHandler = (e?: React.ReactEventHandler) => {
    setIsFrenchSelected(!isFrenchSelected);
  };
  const resetData = {
    limitType: "",
    isZeroLimit: "",
    dataSourceType: "",
    isEntitlement: false,
    isFilterApplicableClasses: false,
    weight: "",
    sourceCalculationStepId: "",
    sourceManualDataSourceId: "",
  };
  const {
    data: distribution,
    isLoading: isLoadingDistribution,
    status: distributionListStatus,
  } = useGetDistributionApiDataQuery(caseId);
  const [isVisibleCancel, setIsVisibleCancel] = useState(false);
  const [createLimitAmount] = useCreateLimitAmountMutation();
  const [updateLimitAmount] = useUpdateLimitAmountMutation();
  const distributionId = watch("distribution");
  const { data: calculationStep, isFetching: stepCaluclationFetching } =
    useGetListCalculationStepQuery(
      {
        distributionId: distributionId,
        pageSize: 10000,
        SortColumn: "SortOrder",
      },
      { skip: !distributionId }
    );
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const getDataSource = watch("dataSource");
  const manualDataSourceList = renderOptionList(
    manualDataSource,
    "name",
    "id",
    defaultOption
  );
  const futureReferencingLogicValue = watch("futureReferencingLogic");
  const { distributionId: currentDistributionId } = useParams<{
    distributionId: string;
  }>();
  const {
    data: distributionWithSequence,
    isLoading: distributionWithSequenceLoading,
    isFetching: isDistributionSequenceFetching,
    status: distributionWithSequenceStatus,
  } = useGetDistributionWithSameSequenceIdQuery(currentDistributionId, {
    skip: !currentDistributionId,
  });
  const { data: limitAmountDataById, isLoading: limitAmountApiLoading } =
    useGetLimitAmountSummaryApiDataQuery(
      {
        limitAmountId: editId,
      },
      {
        skip: !(
          ["fulfilled", "rejected"].includes(distributionWithSequenceStatus) &&
          ["fulfilled", "rejected"].includes(distributionListStatus)
        ),
      }
    );

  const currentDistributionYear = getDistributionYear(
    currentDistributionId,
    distribution
  );
  const filteredDistributionList = distribution?.results?.filter(
    (item: any) => {
      if (futureReferencingLogicValue && futureReferencingLogicValue === "1") {
        const distributionYear = new Date(item.distributionDate).getFullYear();
        if (
          currentDistributionYear !== null &&
          distributionYear < currentDistributionYear
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
  );
  const distributionList = renderOptionList(
    filteredDistributionList,
    "name",
    "id",
    defaultOption
  );
  const currentDistributionSeqYear =
    distributionStepContextData.currentDistributionYear;
  const filteredDistributionListSeq = distributionWithSequence?.results?.filter(
    (item: any) => {
      if (futureReferencingLogicValue && futureReferencingLogicValue === "1") {
        const distributionYear =
          item?.distributionDate !== null
            ? new Date(item.distributionDate).getFullYear()
            : null;
        if (
          distributionYear &&
          currentDistributionSeqYear !== null &&
          distributionYear < currentDistributionSeqYear
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
  );

  const distributionListSeq = renderOptionList(
    filteredDistributionListSeq,
    "name",
    "id",
    defaultOption
  );
  const calculationStepList = renderOptionList(
    calculationStep?.results ? calculationStep.results : [],
    "name",
    "id",
    defaultOption
  );
  // function isNumeric(value: any) {
  //   return /^\d+(\.\d+)?$/.test(value);
  // }
  const errorList = Object.keys(errors);
  const errorsShow = capitalizeWordsInSentence(errorList.join(", "));

  const onSubmit = async (data: any) => {
    let inputValue = data?.weightingFactor;
    if (!(inputValue <= 0 || inputValue >= 0)) {
      // Optionally handle the case where the input is not numeric
      setError("weightingFactor", {
        type: "manual",
        message: "notNumeric",
      });
      return;
    }
    let formData: any = {
      caseId: caseId,
      calculationStepId: stepId,
      limitType: Number(data?.type),
      isZeroLimit: data?.userZeroLimit,
      dataSourceType: Number(data?.dataSource),
      isEntitlement: data?.entitleMentSet === "0" ? true : false,
      isFilterApplicableClasses: data?.filterApplicableClasses || false,
      weight: Number(data?.weightingFactor),
      sourceCalculationStepId: data?.calculationStep || null,
      sourceManualDataSourceId: data?.manualDataSource || null,
      referenceLogic:
        Number(data?.futureReferencingLogic) === 0
          ? 0
          : Number(data?.futureReferencingLogic) || null,
    };
    let updateData: any = {
      id: limitAmountDataById?.id,
      limitType: Number(data?.type),
      isZeroLimit: data?.userZeroLimit,
      dataSourceType: Number(data?.dataSource),
      isEntitlement: data?.entitleMentSet === "0" ? true : false,
      isFilterApplicableClasses: data?.filterApplicableClasses,
      weight: Number(data?.weightingFactor),
      referenceLogic:
        Number(data?.futureReferencingLogic) === 0
          ? 0
          : Number(data?.futureReferencingLogic) || null,
    };
    setIsLoading(true);
    if (editId !== "") {
      const updateResponse: any = await updateLimitAmount(updateData);
      if (updateResponse.hasOwnProperty("data")) {
        setUpdateShow(false);
        setIsLoading(false);
        refetch();
        reset(resetData);
      } else {
        //@ts-ignore
        const error =
          updateResponse.error?.data?.message ||
          t("global.globalNotifications.unExpectedError");
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error,
        });
        setIsLoading(false);
      }
    } else {
      const response:any = await createLimitAmount(formData);
      if (response.hasOwnProperty("data")) {
        setUpdateShow(false);
        setIsLoading(false);
        refetch();
        reset(resetData);
      } else {
        //@ts-ignore
        const error =
          response.error?.data?.message ||
          t("global.globalNotifications.unExpectedError");
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error,
        });
        setIsLoading(false);
      }
    }
  };
  useEffect(() => {
    if (getDataSource !== "1") {
      setIsDistributionSeq(false);
      setValue("futureReferencingLogic", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDataSource]);

  useEffect(() => {
    if (
      limitAmountDataById?.referenceLogic === 0 ||
      limitAmountDataById?.referenceLogic === 1
    ) {
      setIsDistributionSeq(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limitAmountDataById, currentDistributionId]);

  useEffect(() => {
    reset({
      type: limitAmountDataById?.limitType.toString(),
      dataSource: limitAmountDataById?.dataSourceType.toString(),
      entitleMentSet: limitAmountDataById?.isEntitlement === true ? "0" : "1",
      manualDataSource: limitAmountDataById?.sourceManualDataSourceId,
      weightingFactor: limitAmountDataById?.weight,
      filterApplicableClasses: limitAmountDataById?.isFilterApplicableClasses,
      futureReferencingLogic: "" + limitAmountDataById?.referenceLogic,
    });
  }, [reset, limitAmountDataById]);
  useEffect(() => {
    if (distribution !== undefined && limitAmountDataById !== undefined) {
      reset((values: any) => ({
        ...values,
        distribution: limitAmountDataById?.sourceDistributionId,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distribution, limitAmountDataById]);
  let [distributionOptionList, setDistributionOptionList] = useState([
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
  ]);
  useEffect(() => {
    if (limitAmountDataById) {
      let distributionOptionList = isDistributionSeq
        ? distributionListSeq
        : distributionList;
      setDistributionOptionList(distributionOptionList);
      setValue("distribution", "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limitAmountDataById, setValue, isDistributionSeq]);
  useEffect(() => {
    if (!isDirty) {
      setValue("distribution", limitAmountDataById?.sourceDistributionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributionOptionList]);

  useEffect(() => {
    if (calculationStep) {
      reset((values: any) => ({
        ...values,
        calculationStep: limitAmountDataById?.sourceCalculationStepId,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, calculationStep]);

  useEffect(() => {
    if (
      calculationStep !== undefined &&
      limitAmountDataById?.sourceDistributionId !== undefined &&
      calculationStepList.length > 1
    ) {
      reset((values: any) => ({
        ...values,
        calculationStep: limitAmountDataById?.sourceCalculationStepId,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculationStep, limitAmountDataById]);

  // if(futureReferencingLogicValue !=="" && futureReferencingLogicValue !== undefined && futureReferencingLogicValue !== null ){
  //   distributionOptionList=isDistributionSeq ? distributionListSeq : distributionList
  // }

  const cancelBtnApproveHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setUpdateShow(false);
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
    reset(resetData);
  };

  const cancelBtnRejectHandler = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    setIsVisibleCancel(false);
    setShowMessage({ ...showMessage, show: false, type: "error" });
  };

  function handleFutureReferencingLogicChange(value: any) {
    setValue("distribution", "");
    if (value === "1" || value === "0") {
      setIsDistributionSeq(true);
    } else {
      setIsDistributionSeq(false);
    }
  }
  if (
    isLoadingDistribution ||
    distributionWithSequenceLoading ||
    limitAmountApiLoading
  ) {
    return <MotifProgressLoader show variant="default" />;
  }

  return (
    <>
      <MotifModal
        onClose={() => {
          if (isDirty) {
            setIsVisibleCancel(true);
          } else {
            setUpdateShow(false);
            setIsVisibleCancel(false);
            reset(resetData);
          }
        }}
        show={updateShow}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
        size={"xl"}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="formModalWrapper">
            <MotifModalHeader>
              <span className="discard_heading">
                {editId
                  ? t(
                      "pages.distributions.distributionStepsTab.limitAmountTab.limitFormEdit.title"
                    )
                  : t(
                      "pages.distributions.distributionStepsTab.limitAmountTab.limitFormCreate.title"
                    )}
              </span>
            </MotifModalHeader>
            <MotifModalBody>
              {showMessage.show && showMessage.type === "error" && (
                <NotificationGrid
                  show={showMessage.show}
                  message={showMessage.message}
                  type={showMessage.type}
                />
              )}
              <div className="formModal">
                <div className="motif-row">
                  <div className="motif-col-xs-12 motif-col-md-4 motif-col-lg-4">
                    <ControlSelect
                      name={"type"}
                      //@ts-ignore
                      control={control}
                      required={true}
                      showLabel={true}
                      readonly={true}
                      disabled={resolvedStatus}
                      label={
                        "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.type"
                      }
                      //@ts-ignore
                      placeholder={"placeholder"}
                      options={[
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.typeOptions.label"
                          ),
                          value: "",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.typeOptions.label1"
                          ),
                          value: "0",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.typeOptions.label2"
                          ),
                          value: "1",
                        },
                      ]}
                    />
                    {errors["type"] && errors["type"].type === "required" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.typeRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                  </div>
                  <div className="motif-col-xs-12 motif-col-md-4 motif-col-lg-4">
                    <ControlSelect
                      name={"dataSource"}
                      //@ts-ignore
                      control={control}
                      required={true}
                      showLabel={true}
                      readonly={true}
                      label={
                        "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.datasource"
                      }
                      disabled={(editId !== "" && true) || resolvedStatus}
                      //@ts-ignore
                      placeholder={"placeholder"}
                      options={[
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label1"
                          ),
                          value: "",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label2"
                          ),
                          value: "0",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label3"
                          ),
                          value: "1",
                        },
                        {
                          label: t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.dataSourceOptions.label4"
                          ),
                          value: "2",
                        },
                      ]}
                    />
                    {errors["dataSource"] &&
                      errors["dataSource"].type === "required" && (
                        <MotifErrorMessage>
                          {t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.dataSourceRequired"
                          )}
                        </MotifErrorMessage>
                      )}
                  </div>
                  {getDataSource === "1" && (
                    <div className="motif-col-xs-12 motif-col-md-4 motif-col-lg-4">
                      <ControlSelect
                        name={"entitleMentSet"}
                        //@ts-ignore
                        control={control}
                        required={true}
                        showLabel={true}
                        readonly={true}
                        disabled={resolvedStatus || (editId !== "" && true)}
                        label={
                          "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.entitlement"
                        }
                        //@ts-ignore
                        placeholder={"placeholder"}
                        options={[
                          {
                            label: t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.entitlementOptions.label1"
                            ),
                            value: "",
                          },
                          {
                            label: t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.entitlementOptions.label2"
                            ),
                            value: "0",
                          },
                          {
                            label: t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.entitlementOptions.label3"
                            ),
                            value: "1",
                          },
                        ]}
                      />
                      {errors["entitleMentSet"] &&
                        errors["entitleMentSet"].type === "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.entitlementRequired"
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  )}

                  {getDataSource === "2" && (
                    <div className="motif-col-xs-12 motif-col-md-4 motif-col-lg-4">
                      <ControlSelect
                        name={"manualDataSource"}
                        //@ts-ignore
                        control={control}
                        required={true}
                        showLabel={true}
                        readonly={true}
                        disabled={(editId !== "" && true) || resolvedStatus}
                        label={
                          "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.manualDataSource"
                        }
                        //@ts-ignore
                        placeholder={"placeholder"}
                        options={manualDataSourceList}
                      />
                      {errors["manualDataSource"] &&
                        errors["manualDataSource"].type === "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.manualDataSourceRequired"
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  )}
                </div>
                {getDataSource === "1" && (
                  <div className="motif-row">
                    <div
                      className="motif-col-xs-12 motif-col-md-8 motif-col-lg-8"
                      style={{ marginTop: "20px" }}
                    >
                      <FutureReferencingLogic
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        disabled={true}
                        selectedId={
                          limitAmountDataById?.referenceLogic !== null
                            ? limitAmountDataById?.referenceLogic?.toString()
                            : ""
                        }
                        handleChange={handleFutureReferencingLogicChange}
                      />
                      {errors["futureReferencingLogic"] &&
                        errors["futureReferencingLogic"].type ===
                          "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.dataSourceTab.validationMessages.futureReferencingLogicReq",
                              { fieldNames: errorsShow }
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  </div>
                )}

                {getDataSource === "1" && (
                  <div>
                    <div className="motif-row">
                      <div
                        className="motif-col-xs-12 motif-col-md-8 motif-col-lg-8"
                        style={
                          getDataSource === "1" ? { marginTop: "20px" } : {}
                        }
                      >
                        <ControlSelect
                          name={"distribution"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          label={
                            "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.distribution"
                          }
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={distributionOptionList}
                          disabled={(editId !== "" && true) || resolvedStatus}
                        />
                        {errors["distribution"] &&
                          errors["distribution"].type === "required" && (
                            <MotifErrorMessage>
                              {t(
                                "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.distributionRequired"
                              )}
                            </MotifErrorMessage>
                          )}
                      </div>
                      {isDistributionSequenceFetching && (
                        <MotifProgressLoader
                          className="align-self-center mar-t-20"
                          variant="circular"
                          size="xs"
                        ></MotifProgressLoader>
                      )}
                    </div>
                    <div className="motif-row">
                      <div
                        className="motif-col-xs-12 motif-col-md-8 motif-col-lg-8"
                        style={{ marginTop: "20px" }}
                      >
                        <ControlSelect
                          name={"calculationStep"}
                          //@ts-ignore
                          control={control}
                          required={true}
                          showLabel={true}
                          readonly={true}
                          filter={true}
                          label={
                            "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.calculationStep"
                          }
                          disabled={
                            (editId !== "" && true) ||
                            stepCaluclationFetching ||
                            resolvedStatus
                          }
                          //@ts-ignore
                          placeholder={"placeholder"}
                          options={calculationStepList}
                        />
                        {errors["calculationStep"] &&
                          errors["calculationStep"].type === "required" && (
                            <MotifErrorMessage>
                              {t(
                                "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.caluclationStepRequired"
                              )}
                            </MotifErrorMessage>
                          )}
                      </div>
                      {stepCaluclationFetching && (
                        <MotifProgressLoader
                          className="align-self-center mar-t-40"
                          variant="circular"
                          size="xs"
                        ></MotifProgressLoader>
                      )}
                    </div>
                  </div>
                )}

                <div className="motif-row">
                  <div
                    className="motif-col-xs-12 motif-col-md-4 motif-col-lg-4"
                    style={
                      getDataSource === "1" || getDataSource === "2"
                        ? { marginTop: "20px" }
                        : {}
                    }
                  >
                    <ControlInputBoxNumber
                      name={"weightingFactor"}
                      // @ts-ignore
                      control={control}
                      required={true}
                      isTextArea={false}
                      label={
                        "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.weightingFactor"
                      }
                      showLabel={true}
                      isNumber={true}
                      digitAfterDecimal={8}
                      isAmount={true}
                      onChangeAmount={() => {}}
                      validate={isNumericOrNull}
                      readonly={resolvedStatus}
                    />
                    {errors["weightingFactor"] &&
                      errors["weightingFactor"].type === "required" && (
                        <MotifErrorMessage>
                          {t(
                            "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.weighingRequired"
                          )}
                        </MotifErrorMessage>
                      )}
                    {errors["weightingFactor"]?.type === "validate" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.weighingNumericRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                  </div>
                </div>
                <div className="motif-row">
                  <div className="motif-col-xs-12 motif-col-md-4 motif-col-lg-4 mar-t-40">
                    <div style={{ position: "relative", top: "10px" }}>
                      <ControlCheckBox
                        id="checkbox-french-selection"
                        onChange={checkBoxHandler}
                        checked={isFrenchSelected}
                        value={isFrenchSelected}
                        name={"filterApplicableClasses"}
                        control={control}
                        required={false}
                        disabled={resolvedStatus}
                        label={t(
                          "pages.distributions.distributionStepsTab.limitAmountTab.formLabels.applicable"
                        )}
                        setIsFrenchSelected={setIsFrenchSelected}
                      />
                      {errors["filterApplicableClasses"] &&
                        errors["filterApplicableClasses"].type ===
                          "required" && (
                          <MotifErrorMessage>
                            {t(
                              "pages.distributions.distributionStepsTab.limitAmountTab.validationMessages.applicableRequired"
                            )}
                          </MotifErrorMessage>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </MotifModalBody>
            <MotifModalFooter>
              <div className="button-container-add">
                <Button
                  variant={SAVE_BUTTON_VARIANT}
                  loading={isLoading}
                  label={t("global.globalActions.save")}
                  disabled={isLoading || resolvedStatus}
                />
                <Button
                  label={t("global.globalActions.cancel")}
                  type="button"
                  variant={CANCEL_BUTTON_VARIANT}
                  className="cancelBtn"
                  onClickHandler={() => {
                    if (isDirty) {
                      setIsVisibleCancel(true);
                    } else {
                      setUpdateShow(false);
                      setIsVisibleCancel(false);
                    }
                  }}
                />
              </div>
            </MotifModalFooter>
          </div>
        </form>
      </MotifModal>
      <ConfirmationModal
        isVisible={isVisibleCancel}
        setIsVisible={setIsVisibleCancel}
        cancelBtnApproveHandler={cancelBtnApproveHandler}
        cancelBtnRejectHandler={cancelBtnRejectHandler}
      />
    </>
  );
}
